import { FlightData } from "../interfaces/flightData";

export const FLIGHTS_DATA: FlightData[] = [
  {
    categoryName: "Light Jets",
    min_capicity: 4,
    max_capicity: 6,
    min_range: 1000,
    max_range: 1300,
    min_flight_hours: 2.5,
    max_flight_hours: 4,
    avgSpeed: 460,
    price: 3800,
    jets: ["Cessna Mustang ", "Phenom 100 ", "Learjet 35"],
    image: "/assets/images/flights/light_jet.jpeg",
  },
  {
    categoryName: "Super Light Jets",
    min_capicity: 5,
    max_capicity: 6,
    min_range: 1000,
    max_range: 1800,
    min_flight_hours: 3,
    max_flight_hours: 4,
    avgSpeed: 518,
    price: 4500,
    jets: [
      "Learjet 40XR, 60XR",
      "Hawker 400XP",
      "Phenom 300",
      "Falcon 10",
      "Citation CJ1-CJ4, Bravo, Encore",
    ],
    image: "/assets/images/flights/super_light_jet.jpeg",
  },
  {
    categoryName: "Mid Size Jet",
    min_capicity: 5,
    max_capicity: 10,
    min_range: 2000,
    max_range: 3000,
    min_flight_hours: 4,
    max_flight_hours: 6,
    avgSpeed: 492,
    price: 5250,
    image: "/assets/images/flights/mid_size_jet.jpeg",

    jets: [
      "Citation XLS, Columbus, and Sovereign",
      "Legacy 450 and 500",
      "Learjet 60 XR or 85",
      "Falcon 20",
      "Hawker 750, 850XP, and 900XP",
      "Gulfstream 150 and 250",
      "Citation X",
    ],
  },
  {
    categoryName: "Super Mid Size Jet",
    min_capicity: 8,
    max_capicity: 13,
    min_range: 3000,
    max_range: 4000,
    min_flight_hours: 5,
    max_flight_hours: 7,
    avgSpeed: 631,
    price: 6500,
    jets: [
      "Falcon 2000 and 900DX",
      "Legacy 600, 650",
      "Gulfstream G250",
      "Gulfstream G150",
      "Challenger 300",
      "Hawker 4000",
      "Challenger 604,605",
    ],
    image: "/assets/images/flights/super_mid_size_jet.jpeg",
  },
  {
    categoryName: "Large and Heavy",
    min_capicity: 10,
    max_capicity: 16,
    min_range: 4000,
    max_range: 7000,
    min_flight_hours: 5,
    max_flight_hours: 8,
    avgSpeed: 514,
    price: 8500,
    jets: [
      "Global Express, 5000, 5500",
      "Challenger 650, 850",
      "Falcon 7x, 8X",
      "Gulfstream G4, G450",
      "Lineage 1000",
    ],
    image: "/assets/images/flights/large_and_heavy.jpeg",
  },
  {
    categoryName: "Ultra Long Range",
    min_capicity: 10,
    max_capicity: 16,
    min_range: 5200,
    max_range: 7000,
    min_flight_hours: 1,
    max_flight_hours: 16,
    avgSpeed: 552,
    price: 10500,
    jets: [
      "Falcon 7X, 8X",
      "Global 6000, 6500, 7500",
      "Gulfstream G500, G550, G600, G650, G650XR",
    ],
    image: "/assets/images/flights/ultra_long_range.jpeg",
  },
  {
    categoryName: "VIP Ultra Heavy (Narrow Body)",
    min_capicity: 18,
    max_capicity: 40,
    min_range: 6000,
    max_range: 11800,
    min_flight_hours: 10,
    max_flight_hours: 15,
    avgSpeed: 552,
    price: 16800,
    jets: ["Airbus A318, A319, A320", "Boeing B737-500, BBJ1, BBJ2, BBJ3"],
    image: "/assets/images/flights/vip_ultra_heavy.jpeg",
  },
  {
    categoryName: "VIP Ultra Heavy (Wide Body)",
    min_capicity: 18,
    max_capicity: 40,
    min_range: 6000,
    max_range: 11800,
    min_flight_hours: 12,
    max_flight_hours: 18,
    avgSpeed: 552,
    price: 35000,
    jets: ["Airbus A330, A340", "Boeing B767, B787 Dreamliner"],
    image: "/assets/images/flights/ultra_heavy_heavy_body.jpeg",
  },
];
